import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

import {
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	RestService,
} from 'cargo-chief-commons';

import { CARGOCHIEF_KEYS, NOTIFICATIONS } from '@domain/constants/app-variables';
import { UtilService } from '@service/util/util.service';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { NotificationSetting } from '@domain/interface/notification-setting';
import { finalize } from 'rxjs/operators';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { MtxPopoverTrigger } from '@ng-matero/extensions/popover';
import { ProductsService } from '@service/products/products.service';
import { environment } from '@environment/environment';

@Component({
	selector: 'app-notification-popover',
	templateUrl: './notification-popover.component.html',
	styleUrls: ['./notification-popover.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class NotificationPopoverComponent implements OnInit {
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	environment = environment;

	isRequestInProgress: boolean = false;

	@ViewChild(MtxPopoverTrigger) notificationPopover: MtxPopoverTrigger;
	@ViewChild('baPanel') baPanel: MatExpansionPanel;
	@ViewChild('loadsPanel') loadsPanel: MatExpansionPanel;
	@ViewChild('carriersPanel') carriersPanel: MatExpansionPanel;
	@ViewChild('projectsPanel') projectsPanel: MatExpansionPanel;
	@ViewChild('rfpsPanel') rfpsPanel: MatExpansionPanel;

	notificationSettings: Array<NotificationSetting> = [];
	notificationSettingsModel: any = null;
	isModelInitialized: boolean = false;

	constructor(
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		private cargochief: Cargochief,
		public productsService: ProductsService
	) {}

	ngOnInit(): void {}

	setSettings() {
		if (IS_NULL_OR_UNDEFINED(this.cargochief.getItem(CARGOCHIEF_KEYS.NOTIFICATION_SETTINGS))) {
			this.getNotificationSettings();
		} else {
			if (this.notificationSettings?.length == 0) {
				const notificationsString: string = this.cargochief.getItem(
					CARGOCHIEF_KEYS.NOTIFICATION_SETTINGS
				);
				if (IS_NOT_EMPTY(notificationsString)) {
					this.notificationSettings = JSON.parse(notificationsString);
					if (this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper()) {
						this.setuserNotificationsModel();
					} else if (this.utilService.isAccountTypeCarrier()) {
						this.setCarrierNotifications();
					}
				}
			}
		}
	}

	getNotificationSettings() {
		const url = this.urlService.notificationSettings();
		this.restService.GET(url).subscribe(
			(response) => {
				this.notificationSettings = response.data;
				if (this.notificationSettings?.length > 0) {
					this.setuserNotificationsModel();
				}
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to fetch notification settings',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	setuserNotificationsModel() {
		this.notificationSettingsModel = {
			[NOTIFICATIONS.BA_BID_ACCEPTED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_BID_ACCEPTED
			),
			[NOTIFICATIONS.BA_BID_COUNTER]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_BID_COUNTER
			),
			[NOTIFICATIONS.BA_BID_DECLINE]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_BID_DECLINE
			),

			[NOTIFICATIONS.BA_BOOKING_CONFIRMATION]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_BOOKING_CONFIRMATION
			),
			[NOTIFICATIONS.BA_LOAD_CANCEL]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_LOAD_CANCEL
			),
			[NOTIFICATIONS.BA_BOOKING_CONFIRMED_BROKER]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_BOOKING_CONFIRMED_BROKER
			),
			[NOTIFICATIONS.BA_BOOKING_SIGNATURE_BROKER]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_BOOKING_SIGNATURE_BROKER
			),
			[NOTIFICATIONS.BA_LOAD_OWNER_UPDATE]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.BA_LOAD_OWNER_UPDATE
			),
			[NOTIFICATIONS.MULTIPLE_BIDDING]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.MULTIPLE_BIDDING
			),

			[NOTIFICATIONS.RFP_CARRIER_NOT_AVAILABLE]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.RFP_CARRIER_NOT_AVAILABLE
			),
			[NOTIFICATIONS.PROJECT_BEST_RATE_UPDATED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.PROJECT_BEST_RATE_UPDATED
			),
			[NOTIFICATIONS.PROJECT_OWNER]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.PROJECT_OWNER
			),
			[NOTIFICATIONS.PROJECT_RATE_RECEIVED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.PROJECT_RATE_RECEIVED
			),
			[NOTIFICATIONS.PROJECT_CARRIER_PROCURED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.PROJECT_CARRIER_PROCURED
			),
			[NOTIFICATIONS.CHECK_PROJECT]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.CHECK_PROJECT
			),

			[NOTIFICATIONS.TASK_ASSIGNED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.TASK_ASSIGNED
			),
			[NOTIFICATIONS.USER_ASSIGNED_TO_CARRIER]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.USER_ASSIGNED_TO_CARRIER
			),
			[NOTIFICATIONS.CARRIER_EXCLUDED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.CARRIER_EXCLUDED
			),
			[NOTIFICATIONS.LOAD_FILE_RECEIVED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.LOAD_FILE_RECEIVED
			),
			[NOTIFICATIONS.CARRIER_ONBOARDING_REQUESTED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.CARRIER_ONBOARDING_REQUESTED
			),
		};

		for (var setting in this.notificationSettingsModel) {
			if (!this.notificationSettingsModel[setting]) {
				delete this.notificationSettingsModel[setting];
			}
		}
		this.isModelInitialized = true;
	}

	setCarrierNotifications() {
		this.notificationSettingsModel = {
			[NOTIFICATIONS.BA_BOOKING_CONFIRMED_CARRIER]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BOOKING_CONFIRMED_CARRIER
			),
			[NOTIFICATIONS.BA_BROKER_BID_COUNTER]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BROKER_BID_COUNTER
			),
			[NOTIFICATIONS.BA_BID_CANCEL]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BID_CANCEL
			),
			[NOTIFICATIONS.BA_LOAD_UPDATED]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_LOAD_UPDATED
			),
			[NOTIFICATIONS.BA_LOAD_BOOKED_CARRIER]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_LOAD_BOOKED_CARRIER
			),
			[NOTIFICATIONS.BA_BID_INVITE]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BID_INVITE
			),
			[NOTIFICATIONS.BA_BOOKING_SIGNATURE_CARRIER]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BOOKING_SIGNATURE_CARRIER
			),
			[NOTIFICATIONS.BA_BOOKING_CONFIRMATION_CARRIER]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BOOKING_CONFIRMATION_CARRIER
			),

			// [NOTIFICATIONS.EMAIL_MAPPED_CARRIER]: this.notificationSettings.find(
			// 	(notification) => notification.name === NOTIFICATIONS.EMAIL_MAPPED_CARRIER
			// ),
			[NOTIFICATIONS.MY_CARRIER_PACKETS]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.MY_CARRIER_PACKETS
			),

			// carrier notifications
			[NOTIFICATIONS.NEW_BROKER_CONNECTED]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.NEW_BROKER_CONNECTED
			),
			[NOTIFICATIONS.BA_BROKER_BID_COUNTER]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BROKER_BID_COUNTER
			),
			[NOTIFICATIONS.BA_BID_SELECT]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BID_SELECT
			),
			[NOTIFICATIONS.BA_BID_INVITE]: this.notificationSettings.find(
				(notification) => notification.name === NOTIFICATIONS.BA_BID_INVITE
			),
			[NOTIFICATIONS.CARRIER_ONBOARDING_REQUESTED]: this.notificationSettings.find(
				(notification) => notification?.name === NOTIFICATIONS.CARRIER_ONBOARDING_REQUESTED
			),
		};
		this.isModelInitialized = true;
	}

	isBookingAssistant(): boolean {
		return (
			this.productsService.BOOKING_ASSISTANT &&
			(this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper())
		);
	}

	closeNotificationPopover() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.notificationPopover)) {
			this.notificationPopover.closePopover();
		}
	}

	updateUserNotificationSettings() {
		this.isRequestInProgress = true;
		let payload: any = { settings: [] };
		for (let key in this.notificationSettingsModel) {
			payload.settings.push(this.notificationSettingsModel[key]);
		}
		const url = this.urlService.notificationSettings();
		this.restService
			.PUT(url, payload)
			.pipe(
				finalize(() => {
					this.isRequestInProgress = false;
				})
			)
			.subscribe(
				(response) => {
					this.utilService.showSnackbar(
						'Notification settings updated successfully',
						SNACKBAR.SUCCESS,
						SNACKBAR.ACTION
					);
					this.cargochief.setItem({ [CARGOCHIEF_KEYS.NOTIFICATION_SETTINGS]: response.data });
				},
				(error) => {
					this.utilService.showSnackbar(
						'Unable to update notification settings',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				}
			);
	}

	openNotificationPopoverWithPanelExpanded({ panelToOpen }) {
		if (
			IS_NOT_NULL_OR_UNDEFINED(this.notificationPopover && this.notificationPopover.popoverClosed)
		) {
			this.setSettings();
			this.notificationPopover.openPopover();
			let notificationsPopover: any = document.getElementsByClassName('notifications-margin-top');
			if (notificationsPopover?.length) {
				notificationsPopover = notificationsPopover[0];
				notificationsPopover.classList.add('ba_popover');
			}
			this.closeAllPanels();
			setTimeout(() => {
				const maxExpansionPanel: MatExpansionPanel = this.getExpansionPanelComponent({
					panelToOpen,
				});
				maxExpansionPanel?.close();
				maxExpansionPanel?.open();
			}, 500);
		}
	}

	getExpansionPanelComponent({ panelToOpen }): MatExpansionPanel {
		if (panelToOpen == 'loads') {
			return this.loadsPanel;
		}
		if (panelToOpen == 'carriers') {
			return this.carriersPanel;
		}
		if (panelToOpen == 'projects') {
			return this.projectsPanel;
		}
		if (panelToOpen == 'rfps') {
			return this.rfpsPanel;
		}
		if (panelToOpen == 'booking-assistant-automation') {
			return this.baPanel;
		}
	}

	closeAllPanels() {
		this.loadsPanel?.close();
		this.carriersPanel?.close();
		this.projectsPanel?.close();
		this.rfpsPanel?.close();
		this.baPanel?.close();
	}
}
